import React from 'react';
import MUIDataTable from 'mui-datatables';
import { Tooltip, IconButton } from '@material-ui/core';
import { Refresh } from '@material-ui/icons';
import { Skeleton } from '@material-ui/lab';

const placeholderData: {[key: string]: string}[] = [{}, {}, {}, {}, {}];

interface IMUITableLoadingProps {
  hasFilter?: boolean;
  selectable?: 'none' | 'multiple' | 'single';
  withRefresh?: boolean;
  columns: string[];
}

const MUITableLoading: React.FC<IMUITableLoadingProps> = ({ hasFilter, selectable, columns, withRefresh }) => {
  const renderLoading = () => {
    return <Skeleton animation="wave" height={35} />;
  };

  const loadingColumns = columns.map(columnName => ({
    name: columnName,
    options: {
      customBodyRender: renderLoading,
    },
  }));

  function renderRefreshList() {
    return (
      <Tooltip title="Refresh contents">
        <IconButton aria-label="refresh" disabled>
          <Refresh />
        </IconButton>
      </Tooltip>
    );
  }

  return (
    <MUIDataTable
      title={withRefresh ? renderRefreshList() : undefined}
      data={placeholderData}
      columns={loadingColumns}
      options={{
        selectableRows: selectable,
        filter: hasFilter,
      }}
    />
  );
};

MUITableLoading.defaultProps = {
  hasFilter: true,
  selectable: 'multiple',
  withRefresh: false,
};

export default MUITableLoading;
